<template>
  <el-dialog
      :close-on-click-modal="false"
      :title="'预支/借支款费用审核'"
      :lock-scroll="true"
      :visible.sync="dialogFormVisible"
      width="500px"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form @sub="sub" :noSubBtn="true" ref="customForm" :formData="formData" labelWidth="150px">
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="customFormPost('fail')"
                 :loading="failLoading || getDetailLoading"
      >审核不通过</el-button>
      <el-button
          type="primary"
          @click="customFormPost('pass')"
          :loading="subLoading || getDetailLoading"
      >审核通过</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  saveOrderMoneyTypeVerifyResult,
} from 'api/operate';
export default {
  data () {
    return {
      proof: [],
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      failLoading: false, // 审核不通过提交loading
      originData: {},
      branchPredictionLabel: '超出',
      formData: {
        acctNoOptions: [], // 账户名称
        form: [
          {
            label: '预支金额',
            value: 'moneyTypeValueDouble',
            type: 'show',
          },
          {
            label: '实际金额',
            value: 'moneyValuePayDouble',
            type: 'show',
          },
          {
            label: '预支结果',
            value: 'branchPrediction',
            type: 'show',
            color: '',
            // color:'green'
          },
          {
            label: '凭证',
            value: 'file',
            type: 'img',
            accept: 'image/*',
            attr: {
              limit: 1,
            },
            disabled: true,
            default: [],
          },
          {
            label: '备注',
            value: 'remarks',
            type: 'show',
          },
          {
            label: '审核意见',
            value: 'opinion',
            type: 'input',
            // hide:true
          },
        ],
        rules: {
          opinion: [
            { required: false, message: '请输入审核意见', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    show (item, label) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$refs.customForm && this.$refs.customForm.reset();
      this.originData = item;
      this.proof = this.parseProofList(this.originData.proof);
      setTimeout(() => {
        this.setDefaultData();
      }, 1);
    },
    parseProofList (proof) {
      if (!proof) {
        return [];
      }
      if (Array.isArray(proof)) {
        return proof;
      }
      if (typeof proof !== 'string') {
        return [];
      }
      try {
        return JSON.parse(proof);
      } catch (err) {
        // COS 签名链接里 response-content-disposition 可能带 filename="xxx"，
        // 历史数据未转义时会打断 JSON.parse；只把 URL 参数中的裸双引号编码掉，不改变对象结构。
        const normalizedProof = proof
          .replace(/&quot;/g, '"')
          // 历史 COS 签名 URL 可能被保存成 q-sign-algorithm":"sha1&q-ak":"...，
          // 这里仅修复 URL query 参数里的 key":"value 为 key=value，避免破坏外层 JSON 字段。
          .replace(/([?&][A-Za-z0-9_-]+)":"/g, '$1=')
          .replace(/(filename\*=UTF-8''[^",}\]]*)"/g, '$1%22')
          .replace(/(filename=)"([^"\r\n]*)"/g, '$1%22$2%22');
        try {
          return JSON.parse(normalizedProof);
        } catch (parseErr) {
          console.error('[driveApproveDialog] proof JSON parse failed:', parseErr, proof);
          return [];
        }
      }
    },
    setDefaultData () {
      if (this.originData.moneyValuePayDouble > this.originData.moneyTypeValueDouble) {
        this.branchPredictionLabel = '超出';
        this.$refs.customForm.setVal('branchPrediction', this.branchPredictionLabel);
      } else if (this.originData.moneyValuePayDouble < this.originData.moneyTypeValueDouble) {
        this.branchPredictionLabel = '剩余';
        this.$refs.customForm.setVal('branchPrediction', this.branchPredictionLabel);
      } else {
        this.branchPredictionLabel = '收支平衡';
        this.$refs.customForm.setVal('branchPrediction', '收支平衡');
      }
      this.$refs.customForm.setVal('moneyTypeValueDouble', this.originData.moneyTypeValueDouble);
      this.$refs.customForm.setVal('moneyValuePayDouble', this.originData.moneyValuePayDouble);
      this.$refs.customForm.setVal('remarks', this.originData.remarks);
      this.$refs.customForm.formData.form[2].color = this.branchPredictionLabel === '超出' ? 'red' : 'green';

      let files = [];
      this.proof.forEach((element) => {
        files.push({
          id: element.id || element.flowId,
          url: this.normalizeProofUrl(element.picFullUrl || element.fullPath || element.url || element.picUrl),
          storePath: element.picUrl || element.storePath,
        });
      });
      this.$refs.customForm.setVal('file', files);
    },
    normalizeProofUrl (url) {
      return typeof url === 'string' ? url.replace(/&amp;/g, '&') : url;
    },
    hasProof (proof) {
      return this.parseProofList(proof).some((item) => item && (item.flowId || item.id || item.picUrl || item.storePath || item.picFullUrl || item.fullPath || item.url));
    },
    customFormPost (type) {
      if (type === 'fail') {
        this.formData.rules.opinion[0].required = true;
        this.$refs.customForm.sub();
        // }
      } else {
        this.formData.rules.opinion[0].required = false;
        this.subLoading = true;
        this.$refs.customForm.sub();
      }
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      let state = this.formData.rules.opinion[0].required ? 1 : 0;
      let formData = null;
      if (!this.hasProof(this.originData.proof)) {
        this.subLoading = false;
        this.failLoading = false;
        this.$message({
          type: 'warning',
          message: '当前费用凭证未上传或上传未完成，请先上传凭证',
        });
        return;
      }
      if (form) {
        formData = {
          id: this.originData.id,
          orderId: this.originData.orderId,
          auditingStatus: state, // 审核通过传0 不通过传1
          opinion: this.$refs.customForm.getVal('opinion') || '',

        };
      }
      const res = await saveOrderMoneyTypeVerifyResult(formData);
      this.failLoading = false;
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '提交成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
